import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { FilterParams } from '@synergy/models';

import { RegionWithId } from '../models/region';

export class RegionsApi {
    constructor(protected baseUrl: string) {}

    public getRegionsByCountry = async (countryCode: string): Promise<ApiResult<RegionWithId[]>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/regions/${countryCode}`),
            response => response.data
        );
    };

    public searchRegions = async (
        search?: string | null,
        countryCodes?: string[]
    ): Promise<ApiResult<PaginatedResponse<RegionWithId>>> => {
        const params = new URLSearchParams();

        if (search) {
            params.set(FilterParams.Search, search);
        }

        if (countryCodes) {
            params.set('countryCodes', countryCodes.join(','));
        }

        return safeRequest(
            () => request.get(`${this.baseUrl}/regions`, { params }),
            response => response.data
        );
    };
}
